const BluebirdPromise = require('bluebird');
const { chunk } = require('lodash');

const chunkedPromises = async (p, n = 5, iterator) => {
  const chunked = chunk(p, n);
  return BluebirdPromise.mapSeries(chunked, async c => iterator(c));
};

export default chunkedPromises;
